/**
 * Entry point for Botbakery embeddable chat widget
 *
 * This file is the entry point for the widget build. It exports the BotbakeryWidget
 * API that can be used to initialize chat widgets on third-party websites.
 *
 * Usage:
 * ```html
 * <div id="chat-widget"></div>
 * <script src="widget.umd.js"></script>
 * <script>
 *   BotbakeryWidget.init({
 *     apiKey: 'your-api-key',
 *     tenantId: 'your-tenant',
 *     containerId: 'chat-widget'
 *   });
 * </script>
 * ```
 */

// Import base styles (will be bundled into widget.css)
import './src/standalone/widget-styles.scss';

import { BotbakeryWidget } from './src/standalone/widget-init';

// Attach to window for UMD builds
if (typeof window !== 'undefined') {
	(window as any).BotbakeryWidget = BotbakeryWidget;
}

// Export for ESM builds
export { BotbakeryWidget };
export type { WidgetConfig } from './src/standalone/widget-init';
